export default __webpack_public_path__ + "static/media/3.d130a54a.jpg";